export default __webpack_public_path__ + "static/media/atlas-green-hRRjixxRgfQ-unsplash.105a4449.jpg";